import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Axios } from "../../Axios";
import { BASE_URL } from "../../Axios/base_url";
import "./style.css";
import UseGeneral from "../../hooks/useGeneral";
import { Loader } from "rsuite"; // Assuming you have a Loader component
import axios from "axios";

function Branch() {
  const { language } = UseGeneral();
  const [data, setData] = useState("");
  const getSiteInfo = () => {
    axios
      .get(BASE_URL + "site_info/get_all_for_user")
      .then((res) => {
        if (res.data.status == "success") {
          setData(res?.data?.result);
        }
      })
      .catch((e) => console.log(e))
      .finally(() => {
        // setPageLoading(false);
      });
  };
  useEffect(() => {
    getSiteInfo();
  }, []);
  return (
    <div className="BranchPage rowDiv" style={{ margin: "auto" }}>
      <img
        src={
          "https://res.cloudinary.com/duovxefh6/image/upload/v1717445806/map_vogmy6.png"
        }
      />
      <div className={"columnDiv"}>
        <h3
          style={{
            color: "var(--main-color)",
            width: "100%",
            textAlign: "center",
            marginBottom: "40px",
            fontSize: "40px",
          }}
        >
          <b>{language == "ar" ? "فروعنا" : "Our Branches"}</b>
        </h3>
        <p style={{ width: "100%", marginBottom: "40px", fontSize: "20px" }}>
          <b>
            {language == "ar" ? data?.site_location : data?.site_location_en}
          </b>
        </p>
      </div>
    </div>
  );
}

export default Branch;
